import React, { SVGProps } from 'react';

export const ProductsIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 22,
  height = 22,
  fill = '#0063D6',
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 22 22"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.5834 0.166672H3.41675C1.57508 0.166672 0.166748 1.575 0.166748 3.41667V18.5833C0.166748 20.425 1.57508 21.8333 3.41675 21.8333H18.5834C20.4251 21.8333 21.8334 20.425 21.8334 18.5833V3.41667C21.8334 1.575 20.4251 0.166672 18.5834 0.166672ZM6.66675 16.4167C6.66675 17.0667 6.23341 17.5 5.58341 17.5C4.93341 17.5 4.50008 17.0667 4.50008 16.4167V12.0833C4.50008 11.4333 4.93341 11 5.58341 11C6.23341 11 6.66675 11.4333 6.66675 12.0833V16.4167ZM12.0834 16.4167C12.0834 17.0667 11.6501 17.5 11.0001 17.5C10.3501 17.5 9.91675 17.0667 9.91675 16.4167V5.58334C9.91675 4.93334 10.3501 4.5 11.0001 4.5C11.6501 4.5 12.0834 4.93334 12.0834 5.58334V16.4167ZM17.5001 16.4167C17.5001 17.0667 17.0667 17.5 16.4167 17.5C15.7667 17.5 15.3334 17.0667 15.3334 16.4167V9.91667C15.3334 9.26667 15.7667 8.83334 16.4167 8.83334C17.0667 8.83334 17.5001 9.26667 17.5001 9.91667V16.4167Z"
        fill={fill}
      />
    </svg>
  );
};
